import { styled } from '@mui/system';

export const Wrapper = styled('div')(({ theme }) => ({
  height: '50vh',
}));
